import { beyondGallery } from "@/data/portfolio";

export const PhotoBelt = () => {
  const row = [...beyondGallery, ...beyondGallery, ...beyondGallery];
  return (
    <div
      className="relative -mx-4 mt-16 -rotate-[2.5deg] scale-[1.04] overflow-hidden py-6 sm:-mx-8 lg:-mx-16"
      data-testid="photo-belt"
    >
      <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-24 bg-gradient-to-r from-[#050508] to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-24 bg-gradient-to-l from-[#050508] to-transparent" />
      <div className="flex w-max animate-marquee gap-5" style={{ animationDuration: "30s" }}>
        {row.map((shot, i) => (
          <div
            key={i}
            className="h-40 w-60 shrink-0 overflow-hidden rounded-xl border border-white/10 transition-colors duration-300 hover:border-cyan-400/50 sm:h-48 sm:w-72"
          >
            <img
              src={shot.src}
              alt={shot.caption}
              loading="lazy"
              className="h-full w-full object-cover transition-transform duration-700 hover:scale-110"
            />
          </div>
        ))}
      </div>
    </div>
  );
};
